import React,{useState,useEffect} from 'react'
import {Row,Col,Modal} from 'react-bootstrap'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { optionsShowtt, optionsStatus, optionsdept } from '../../Helper'

import ReactPaginate from 'react-paginate'
import PillSmall from '../../subComponents/CustomSubComponents/PillSmall'
import { hrEmployeeSalaryeApi } from '../../../utils/AdminDashApi/HREmployeeSalaryApi'
import Purplebutton from '../desktop/subComponent/Purplebutton'
import { validationComp, validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'
import MobileInputSubComp from './sub_components/MobileInputSubComp'
const HREmployeeSalaryCompmb = () => {
    const [show,setShow] = useState(10)
    const [empnameMod1,setempnameMod1] = useState("")
    const [borderempnameMod1,setborderempnameMod1] = useState("")
    const [labelempnameMod1,setlabelempnameMod1] = useState("")
    const [idMod1,setidMod1] = useState("")
    const [borderidMod1,setborderidMod1] = useState("")
    const [labelidMod1,setlabelidMod1] = useState("")
    const [emailMod1,setemailMod1]= useState("")
    const [labelemailMod1,setlabelemailMod1]= useState("")
    const [borderemailMod1,setborderemailMod1]= useState("")
    const [departmentMod1,setdepartmentMod1]= useState("")
    const [labeldepartmentMod1,setlabeldepartmentMod1]= useState("")
    const [borderdepartmentMod1,setborderdepartmentMod1]= useState("")
    const [roleMod1,setroleMod1]= useState("")
    const [labelroleMod1,setlabelroleMod1]= useState("")
    const [borderroleMod1,setborderroleMod1]= useState("")
    const [statusMod1,setstatusMod1]= useState("")
    const [labelstatusMod1,setlabelstatusMod1]= useState("")
    const [borderstatusMod1,setborderstatusMod1]= useState("")

    const [empnameMod2,setempnameMod2] = useState("")
    const [borderempnameMod2,setborderempnameMod2] = useState("")
    const [labelempnameMod2,setlabelempnameMod2] = useState("")
    const [idMod2,setidMod2] = useState("")
    const [borderidMod2,setborderidMod2] = useState("")
    const [labelidMod2,setlabelidMod2] = useState("")
    const [emailMod2,setemailMod2]= useState("")
    const [labelemailMod2,setlabelemailMod2]= useState("")
    const [borderemailMod2,setborderemailMod2]= useState("")
    const [departmentMod2,setdepartmentMod2]= useState("")
    const [labeldepartmentMod2,setlabeldepartmentMod2]= useState("")
    const [borderdepartmentMod2,setborderdepartmentMod2]= useState("")
    const [roleMod2,setroleMod2]= useState("")
    const [labelroleMod2,setlabelroleMod2]= useState("")
    const [borderroleMod2,setborderroleMod2]= useState("")
    const [statusMod2,setstatusMod2]= useState("")
    const [labelstatusMod2,setlabelstatusMod2]= useState("")
    const [borderstatusMod2,setborderstatusMod2]= useState("")

    const [show2,setShow2] = useState(false)
    const [show3,setShow3] = useState(false)

    const handleClose=()=>{
        setShow2(false)
    }
    const handlesaveModal1=()=>{
      //Mod1validation
      validationDrp(roleMod1,setlabelroleMod1,setborderroleMod1,"Role Required")
      validationDrp(statusMod1,setlabelstatusMod1,setborderstatusMod1,"Status Required")
      validationDrp(departmentMod1,setlabeldepartmentMod1,setborderdepartmentMod1,"Department Required")
      validationComp(emailMod1,setlabelemailMod1,setborderemailMod1,"Email Required")
      validationComp(empnameMod1,setlabelempnameMod1,setborderempnameMod1,"Name Requried")
      validationComp(idMod1,setlabelidMod1,setborderidMod1,"ID Required")
    }
    const handlesaveModal2=()=>{
      //Mod2validation
      validationDrp(roleMod2,setlabelroleMod2,setborderroleMod2,"Role Required")
    validationDrp(statusMod2,setlabelstatusMod2,setborderstatusMod2,"Status Required")
    validationDrp(departmentMod2,setlabeldepartmentMod2,setborderdepartmentMod2,"Department Required")
    validationComp(emailMod2,setlabelemailMod2,setborderemailMod2,"Email Required")
    validationComp(empnameMod2,setlabelempnameMod2,setborderempnameMod2,"Name Requried")
    validationComp(idMod2,setlabelidMod2,setborderidMod2,"ID Required")
    }

    const handlecross=(fullItem)=>{

    }

    const handledownload=(fullitem)=>{
      console.log(fullitem)
    }

    const drpfuncshow=(myval,id)=>{
        setShow(myval)        
      }
    const drpfuncdeptMod1 = (myval,myid) =>{
      setdepartmentMod1(myval)
    }
    const drpfuncroleMod1 = (myval,myid)=>{
      setroleMod1(myval)

    }
      const drpfuncStatusMod1=(myval,myid)=>{

        setstatusMod1(myval)

      }
    const drpfuncdeptMod2 = (myval,myid) =>{
      setdepartmentMod2(myval)
    }
    const drpfuncroleMod2 = (myval,myid)=>{
      setroleMod2(myval)

    }
      const drpfuncStatusMod2=(myval,myid)=>{

        setstatusMod2(myval)

      }

      const handleClose2=()=>{
        setShow3(false)
      }
      const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(hrEmployeeSalaryeApi.data)
  const [tempfilteredarr,settempfilteredarr] = useState([])
  let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
  

  useEffect(() => {
    const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
    const tempArr = filteredArr.slice(itemOffsetfiltered, endOffsetfiltered);
    settempfilteredarr(tempArr);
    setPageCountfiltered(Math.ceil(filteredArr.length / itemsPerPagefiltered));
    setitemsPerPagefiltered(show?show:10)
    //flag2
  }, [itemOffsetfiltered, itemsPerPagefiltered, filteredArr,show]);

      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % hrEmployeeSalaryeApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
      const handleAddNewSalary=()=>{
        setShow2(true)
      }
      //start
  return (
    <>
    <div className="felxvaluecompmbmain">
        <div className="studentdashboardmobilewrapper">
            <div className="mobilecontainer">
                <div className="adminmbheading">
                    <h3>Employee Salary</h3>
                </div>                
                <div className="admbwrap">  
                
                <Purplebutton clickfunc={handleAddNewSalary} w="100%" h="40px" btnname="+ Add New Salary" />
                
                </div>  
                <div className="admbwrap pb0">
                <Row>
                     <MobileInputSubComp col="4" name="Show" direct="left">
                      <div className="dropdownwrapper">
                        
                          <Dropdown2 func={drpfuncshow} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsShowtt}/>
                      </div>
                       </MobileInputSubComp>
                     <MobileInputSubComp col="8" name="Search" direct="right">
                              <div className="wrap">
                              <input type="text" placeholder="Search" value={mainpagesearch} onChange={handlemainpagesearch}/>
                              <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />

                              </div>
                            </MobileInputSubComp>
                  </Row>
                </div> 
                <div className="admbwrap pr0">
                    <div className="tablewrapscroll">
                        <div className="flexvaluetable hrshiftsetuptablediv ">
                        <table>
                      <thead>
                        <tr>
                            {
                              hrEmployeeSalaryeApi.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            tempfilteredarr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td>{item.name}</td>
                                  <td>{item.id}</td>
                                  <td>{item.email}</td>
                                  <td>{item.department}</td>
                                  <td>{item.role}</td>
                                  <td>{item.salary}</td>
                                  
                                  <td>
                                    {
                                        item.status=="Paid"?
                                        <PillSmall class="HRPaid m-auto" bg="#EFFFE7" fontsize="12px" textcolor="#80B563" text={item.status}/>
                                        
                                        :
                                        item.status=="Not Paid"?
                                        <PillSmall class="HRNotpaid m-auto" bg="#FFF0F1" fontsize="12px" textcolor="#FF5454" text={item.status}/>
                                        :
                                        item.status=="Pending"?
                                        <PillSmall class="HRPending m-auto" bg="#FFEFE4" fontsize="12px" textcolor="#F89552" text={item.status}/>
                                        :
                                       
                                        ""
                                    }
                                  </td>
                                  <td className='text-center'><img style={{width:"16px"}} onClick={()=>handledownload(item)} src={item.payslip} alt="" /></td>
                                  <td>
                                      <div className="div w-100 d-flex justify-content-center">
                                        <div className="div d-flex align-items-center">
                                      <img  onClick={()=>setShow3(true)} src={item.action.edit} alt="" style={{margin:"0 6px",width:"16px"}}/>
                                      <img  onClick={()=>handlecross(item)} src={item.action.cross} alt="" style={{margin:"0 6px",width:"16px"}}/>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              )
                            })
                            :
                            ""
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                        </div>
                    </div>
                </div>   
                <div className="admbwrap">
                <Row>
                <Col lg={10} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={5}
                      pageCount={pageCountfiltered}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffset+1} to {itemOffset+10} of {hrEmployeeSalaryeApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      pageCount={pageCount}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>
                </div> 
                       {/* modal1ori */}

                <Modal dialogClassName="mymodal" show={show2} onHide={handleClose} backdrop="static"
                    keyboard={false}>

                    <Modal.Header closeButton>
                        <Modal.Title className="ms-auto" style={{fontSize:"14px"}}>Employee Salary Entry</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <Row>
                        <Col lg={10} className="m-auto">
                            <Row>

                                <MobileInputSubComp col="12" name="Name" direct="center">
                                    <input type="text" style={borderempnameMod1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} value={empnameMod1} onChange={(e) => setempnameMod1(e.target.value)} />
                                    <label>{labelempnameMod1}</label>
                                </MobileInputSubComp>
                                <MobileInputSubComp col="12" name="ID" direct="center">
                                    <div className="dropdownwrapper">
                                        <input type="text" style={borderidMod1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} value={idMod1} onChange={(e) => setidMod1(e.target.value)} />
                                    </div>
                                    <label>{labelidMod1}</label>
                                </MobileInputSubComp>
                                <MobileInputSubComp col="12" name="Email" direct="center">

                                    <div className="dropdownwrapper">

                                        <input type="text" style={borderemailMod1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} value={emailMod1} onChange={(e) => setemailMod1(e.target.value)} />
                                    </div>
                                    <label>{labelemailMod1}</label>
                                </MobileInputSubComp>
                                <MobileInputSubComp col="12" name="Department" direct="center">
                                    <div className="dropdownwrapper" >

                                        <Dropdown2 err={borderdepartmentMod1} func={drpfuncdeptMod1} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsdept} />
                                    </div>
                                    <label>{labeldepartmentMod1}</label>
                                </MobileInputSubComp>

                                <MobileInputSubComp col="12" name="Role" direct="center">

                                    <div className="dropdownwrapper" >

                                        <Dropdown2 err={borderroleMod1} func={drpfuncroleMod1} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsStatus} />
                                    </div>
                                    <label>{labelroleMod1}</label>
                                </MobileInputSubComp>
                                <MobileInputSubComp col="12" name="Status" direct="center">
                                    <div className="dropdownwrapper">

                                        <Dropdown2 err={borderstatusMod1} func={drpfuncStatusMod1} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsStatus} />
                                    </div>
                                    <label>{labelstatusMod1}</label>
                                </MobileInputSubComp>






                            </Row>

                            </Col>

                        </Row>

                    </Modal.Body>
                    <Modal.Footer className="m-auto" style={{ borderTop: "0" }}>
                        <button variant="secondary" type="button" onClick={handleClose}>
                            Close
                        </button>
                        <button variant="primary" onClick={handlesaveModal1}>
                            Save
                        </button>
                    </Modal.Footer>


                </Modal>
                {/* modal2ori */}

                <Modal dialogClassName="mymodal" show={show3} onHide={handleClose2} backdrop="static"
                    keyboard={false}>

                    <Modal.Header closeButton>
                        <Modal.Title className="ms-auto" style={{fontSize:"14px"}}>Employee Salary Entry</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <Row>
                        <Col lg={10} className="m-auto">
                            <Row>

                                <MobileInputSubComp col="12" name="Name" direct="center">
                                    <input type="text" style={borderempnameMod2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} value={empnameMod2} onChange={(e) => setempnameMod2(e.target.value)} />
                                    <label>{labelempnameMod2}</label>
                                </MobileInputSubComp>
                                <MobileInputSubComp col="12" name="ID" direct="center">
                                    <div className="dropdownwrapper">
                                        <input type="text" style={borderidMod2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} value={idMod2} onChange={(e) => setidMod2(e.target.value)} />
                                    </div>
                                    <label>{labelidMod2}</label>
                                </MobileInputSubComp>
                                <MobileInputSubComp col="12" name="Email" direct="center">

                                    <div className="dropdownwrapper">

                                        <input type="text" style={borderemailMod2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} value={emailMod2} onChange={(e) => setemailMod2(e.target.value)} />
                                    </div>
                                    <label>{labelemailMod2}</label>
                                </MobileInputSubComp>
                                <MobileInputSubComp col="12" name="Department" direct="center">
                                    <div className="dropdownwrapper" >

                                        <Dropdown2 err={borderdepartmentMod2} func={drpfuncdeptMod2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsdept} />
                                    </div>
                                    <label>{labeldepartmentMod2}</label>
                                </MobileInputSubComp>

                                <MobileInputSubComp col="12" name="Role" direct="center">

                                    <div className="dropdownwrapper" >

                                        <Dropdown2 err={borderroleMod2} func={drpfuncroleMod2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsStatus} />
                                    </div>
                                    <label>{labelroleMod2}</label>
                                </MobileInputSubComp>
                                <MobileInputSubComp col="12" name="Status" direct="center">
                                    <div className="dropdownwrapper">

                                        <Dropdown2 err={borderstatusMod2} func={drpfuncStatusMod2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsStatus} />
                                    </div>
                                    <label>{labelstatusMod2}</label>
                                </MobileInputSubComp>






                            </Row>

                            </Col>

                        </Row>

                    </Modal.Body>
                    <Modal.Footer className="m-auto" style={{ borderTop: "0" }}>
                        <button variant="secondary" type="button" onClick={handleClose}>
                            Close
                        </button>
                        <button variant="primary" onClick={handlesaveModal2}>
                            Update
                        </button>
                    </Modal.Footer>


                </Modal>  
            </div>
        </div>
    </div>
    </>
  )
}

export default HREmployeeSalaryCompmb